import { render } from "./affiliate-guide.vue?vue&type=template&id=27c4b305"
import script from "./affiliate-guide.vue?vue&type=script&lang=js"
export * from "./affiliate-guide.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__